
"use client";

import Timeline from "@/components/Employee/Timeline/Timeline";
import React from "react";

const TimelinePage = () => {
    return <Timeline />;
};

export default TimelinePage;
